<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h2 class="Verse-head" id="_idParaDest-7"><a id="_idTextAnchor007"></a>Angel Hands</h2>
<p class="Top-quote"><em class="italic _idGenCharOverride-1">La première Ève fut ensevlie hors du jarden</em></p>
<p class="Top-quote-source">Charles Pèguy</p>
<p class="Verse-new">Held by angels</p>
<p class="Verse-main">we’re beckoned</p>
<p class="Verse-main">into unwalled gardens</p>
<p class="Verse-main">welcomed in our body-selves</p>
<p class="Verse-main">us, cobbers, <em class="italic _idGenCharOverride-1">ineinander</em></p>
<p class="Verse-main">night homecoming</p>
<p class="Verse-main">of daylight strangers,</p>
<p class="Verse-main">now winging it,</p>
<p class="Verse-main">intertwined, unafraid</p>
<p class="Verse-main">young and old gifted</p>
<p class="Verse-main">with angel hands</p>
<p class="Verse-main">giving and forgiving.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398400801_EPUB-9.vue?93a24f42